import "core-js/stable"
import "whatwg-fetch"

export default {
    
}